import './style.css';
import React, { useEffect, useState } from 'react';

function Membres() {
    // --- ÉTATS GARCONS ---
    const [dataGarcons, setDataGarcons] = useState([]);
    const [isGarconsOpen, setIsGarconsOpen] = useState(false);

    // --- ÉTATS FILLES ---
    const [dataFilles, setDataFilles] = useState([]);
    const [isFillesOpen, setIsFillesOpen] = useState(false);

    // Fetch Garçons
    useEffect(() => {
        fetch("https://opensheet.elk.sh/1NvpXJgpg6CgpFf9hwV9FI-iY36ETF72DguHuxZZcsKo/garcons")
            /*Chagement: https://opensheet.elk.sh/1Z3zx0k12mO15qEwAvF2wNOB-fUOjZhcka5uM_Xh1GAI/membres-garcons*/
            .then(res => res.json())
            .then(data => {
                const dataWithId = data.map((row, index) => ({
                    id: index + 1,
                    ...row
                }));
                setDataGarcons(dataWithId);
                setIsGarconsOpen(true); // Ouvre auto après chargement
            })
            .catch(err => console.error("Erreur Garçons:", err));
    }, []);

    // Fetch Filles
    useEffect(() => {
        fetch("https://opensheet.elk.sh/1Z3zx0k12mO15qEwAvF2wNOB-fUOjZhcka5uM_Xh1GAI/membres-filles")
            .then(res => res.json())
            .then(data => {
                const dataWithId = data.map((row, index) => ({
                    id: index + 1,
                    ...row
                }));
                setDataFilles(dataWithId);
                setIsFillesOpen(true); // Ouvre auto après chargement
            })
            .catch(err => console.error("Erreur Filles:", err));
    }, []);

    return (
        <div id="membres">

            {/* SECTION FILLES */}
            <section className={`membres-genre ${isFillesOpen ? 'clicked' : ''}`} id="membres-filles">
                <div className="section-title" onClick={() => setIsFillesOpen(!isFillesOpen)}>
                    <svg className={isFillesOpen ? 'rotation' : ''} xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 640 640">
                        <path fill="#ffffff"
                              d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Filles</h2>
                </div>

                <div className={`members-names ${!isFillesOpen ? 'disappear' : ''}`}>
                    {dataFilles.map((row) => (
                        <p key={row.id}>
                            {row.civilite} {row.prenom} {row.particule} {row.nom}
                        </p>
                    ))}
                </div>
            </section>

            <br/><br/>

            {/* SECTION GARÇONS */}
            <section className={`membres-genre ${isGarconsOpen ? 'clicked' : ''}`} id="membres-garcons">
                <div className="section-title" onClick={() => setIsGarconsOpen(!isGarconsOpen)}>
                    <svg className={isGarconsOpen ? 'rotation' : ''} xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 640 640">
                        <path fill="#ffffff"
                              d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                    </svg>
                    <h2>Garçons</h2>
                </div>

                <div className={`members-names ${!isGarconsOpen ? 'disappear' : ''}`}>
                    {dataGarcons.map((row) => (
                        <p key={row.id}>
                            {row.civilite} {row.prenom} {row.particule} {row.nom}
                        </p>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default Membres;